import React from 'react';
import { useSelector } from 'react-redux';
import { DebouncedSearchField } from '../../commonComponents/DebouncedSearchField';
import { SelectFilter } from '../../commonComponents/filters/SelectFilter';
import { stateFilterOptions } from '../../../utils/filters';

// Value semantics preserved from the native selects this replaces: "All" is
// the raw string 'all' for status, '' for state, and the literal 'All' for
// recruiter — the fetch action already speaks those dialects.
const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'draft', label: 'Draft' },
  { value: 'complete', label: 'Completed' },
  { value: 'closed', label: 'Closed' },
];

const STATE_OPTIONS = stateFilterOptions('');

/** The Permanent Jobs list's filter fields, for ListPage's `filters` card. */
export const Filters = ({ filter, handleFilterChange }) => {
  const allPPRecruiters = useSelector((state) => state.pp.allPPRecruiters);

  const recruiterOptions = ['All', ...allPPRecruiters].map((recruiter) => ({
    value: recruiter,
    label: recruiter,
  }));

  return (
    <>
      <DebouncedSearchField
        label="Office name"
        placeholder="Search by office name"
        value={filter?.officeName}
        onChange={(value) => handleFilterChange('officeName', value)}
      />

      <SelectFilter
        label="Status"
        options={STATUS_OPTIONS}
        value={filter.status === '' ? 'all' : filter.status}
        onChange={(status) => handleFilterChange('status', status)}
      />

      <SelectFilter
        label="State"
        options={STATE_OPTIONS}
        value={filter.state}
        onChange={(state) => handleFilterChange('state', state)}
      />

      <DebouncedSearchField
        label="Zip code"
        placeholder="Search by zip code"
        type="number"
        value={filter?.zipCode}
        onChange={(value) => handleFilterChange('zipCode', value)}
      />

      <SelectFilter
        label="Recruiter"
        options={recruiterOptions}
        value={filter.recruiter === '' ? 'All' : filter.recruiter}
        onChange={(recruiter) => handleFilterChange('recruiter', recruiter)}
      />
    </>
  );
};
